import { render, staticRenderFns } from "./LayoutAPI.vue?vue&type=template&id=622e331a&"
import script from "./LayoutAPI.vue?vue&type=script&lang=js&"
export * from "./LayoutAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports